import React, { ComponentType, PropsWithChildren } from 'react'
import { AppLoading } from 'live/components/ui/Loading'

import { ErrorBoundary } from './ErrorBoundary'

export const SuspenseWrapper = ({ children }: PropsWithChildren<{}>): JSX.Element => {
    return (
        <ErrorBoundary>
            <React.Suspense fallback={<AppLoading />}>{children}</React.Suspense>
        </ErrorBoundary>
    )
}

export function withSuspenseWrapper<P>(Component: ComponentType<P>): ComponentType<P> {
    const WrappedBySuspense: React.FC<P> = props => (
        <SuspenseWrapper>
            <Component {...props} />
        </SuspenseWrapper>
    )

    return WrappedBySuspense
}
